import admin from './admin'
import customer from './customer'
import session from './session'
import address from './address'
import security from './security'
import contract from './contract'
import legal from './legal'

export default {
  name: 'User',
  path: 'user',
  meta: {
    label: 'users',
    auth: 'user'
  },
  component: {
    name: 'Users',
    render(c) {
      return c('router-view')
    }
  },
  children: [customer, admin, session, address, security, contract, legal]
}
